export default __webpack_public_path__ + "static/media/plain-sticker-k.7f397d05.png";